export const GCGO_ETHEREUM_URL =
    process.env.REACT_APP_GCGO_ETHEREUM_URL || 'https://ambindexer.net/gcgo';
export const GCGO_SCROLL_URL =
    process.env.REACT_APP_GCGO_SCROLL_URL ||
    'https://ambindexer.net/scroll-gcgo';
export const GCGO_TESTNET_URL =
    process.env.REACT_APP_GCGO_TESTNET_URL ||
    'https://ambindexer.net/gcgo-testnet';
export const GCGO_BLAST_URL =
    process.env.REACT_APP_GCGO_BLAST_URL || 'https://ambindexer.net/blast-gcgo';
export const GCGO_OVERRIDE_URL = process.env.REACT_APP_GCGO_OVERRIDE_URL;
